import { LocationType, PosLocation } from '../models/location.model';
import { TicketSource } from '../models/ticket.model';

export function shouldAutoFire(
  orderSource: TicketSource | undefined,
  { auto_fire_order_on_payment, type: locationType }: PosLocation
): boolean {
  if (!auto_fire_order_on_payment) {
    return false;
  }

  if ([TicketSource.POS_TAKEOUT, TicketSource.PORTAL].includes(orderSource)) {
    return false;
  }

  if (locationType === LocationType.Services) {
    return false;
  }

  return true;
}
